import React from "react";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { EmployeeTable } from "./EmployeeTable";
import { PaginationButtons } from "../../common/components/PaginationButtons";

export const EmployeeActiveList = ({ activeData }) => {
  if (activeData.isPending) return <Loader active />;
  if (activeData.error)
    return <ErrorSegment message={activeData.error.message} />;
  if (activeData.data) {
    return (
      <>
        <EmployeeTable
          employees={activeData.data.results}
          reload={activeData.refetch}
        />
        <PaginationButtons
          previous={activeData.data?.previous}
          next={activeData.data?.next}
          onPrevious={activeData.handlePrevious}
          onNext={activeData.handleNext}
        />
      </>
    );
  }

  return null;
};
